import { usePublicLang } from "@/contexts/PublicLangContext";
import { getPublicFileUrl } from "@/lib/api";
import { getEffectivePricingDisplay } from "@/lib/pricingUtils";
import ScrollReveal from "./ScrollReveal";
import CategoryPlaceholder from "./CategoryPlaceholder";

// Fix D (2026-09-09): vitrina de promociones vigentes, pedida por la clinica
// para traccionar hacia los tratamientos. Se alimenta SOLO de los servicios
// que ya tienen promocion activa (promo_enabled + fechas vigentes), que el
// backend resuelve en pricing.promo_active. Si no hay ninguna, la seccion no
// se renderiza. El texto de precios (tachado/promo) se calcula con el mismo
// helper que usa TreatmentsGallery.jsx (lib/pricingUtils), no se inventan
// campos nuevos.
export default function PromosSection({ services, onBookService }) {
  const { t } = usePublicLang();
  const promos = (services || []).filter((s) => s.pricing?.promo_active);
  if (promos.length === 0) return null;

  return (
    <section id="promociones" className="py-20 md:py-24 px-5" data-testid="landing-promos">
      <ScrollReveal className="max-w-6xl mx-auto">
        <h2 className="font-serif text-3xl md:text-4xl tracking-tight text-[#292522] text-center mb-3">
          {t("landing.promos.sectionTitle")}
        </h2>
        <p className="text-sm text-[#6B6058] text-center mb-10">{t("landing.promos.subtitle")}</p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {promos.map((s) => {
            const pricing = getEffectivePricingDisplay(s);
            return (
              <div key={s.id} className="rounded-xl overflow-hidden border border-[rgba(185,154,98,0.28)] bg-white/70 flex flex-col">
                <div className="relative aspect-[4/3] overflow-hidden">
                  {s.photo_url ? (
                    <img src={getPublicFileUrl(s.photo_url)} alt={s.name} className="w-full h-full object-cover" />
                  ) : (
                    <CategoryPlaceholder category={s.category} name={s.name} />
                  )}
                  <span className="absolute top-3 left-3 text-[10px] font-semibold uppercase tracking-[0.14em] bg-[var(--brand-accent)] text-white px-3 py-1 rounded-full">
                    {s.pricing?.promo_label || t("landing.promos.badge")}
                  </span>
                </div>

                <div className="p-5 flex flex-col gap-2 flex-1">
                  <h3 className="font-serif text-xl text-[#292522]">{s.name}</h3>
                  <div className="flex items-center gap-2 text-sm mt-auto">
                    <span className="line-through text-[#A89582]">{pricing.regularText}</span>
                    <span className="font-medium text-[var(--brand-primary)]">{pricing.promoText}</span>
                  </div>
                  <button
                    type="button"
                    onClick={() => onBookService(s)}
                    className="mt-3 bg-[var(--brand-accent)] text-white text-[11px] font-medium uppercase tracking-[0.16em] px-6 py-3 rounded-md hover:opacity-90 active:scale-95 transition-all"
                    data-testid={`landing-promo-cta-${s.id}`}
                  >
                    {t("landing.treatments.ctaBook")}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </ScrollReveal>
    </section>
  );
}
